// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3kgyq","title":"styles_title__1PCzv"};